import { Axios } from "@/utils/axios";

export const getJangjiRecommendRequests = async () => {
  const { data } = await Axios.get(`/jangji_recommend_requests/`);
  return data;
};
